import { View } from "@react-pdf/renderer";
import {
  ResumePDFIcon,
  type IconType,
} from "components/Resume/ResumePDF/common/ResumePDFIcon";
import { styles, spacing } from "components/Resume/ResumePDF/styles";
import {
  ResumePDFLink,
  ResumePDFSection,
  ResumePDFText,
} from "components/Resume/ResumePDF/common";
import { TemplateTwentyOneProfileSection } from "./common";
import type { ResumeProfile } from "lib/redux/types";
import { extractUsernameFromURL } from "lib/utils/urlHelpers";
import { useFontSize } from "components/Resume/ResumePDF/FontSizeContext";

export const Profile = ({
  profile,
  themeColor,
  isPDF,
  enableHighlight = false,
  enableMistakeHighlight = false,
}: {
  profile: ResumeProfile;
  themeColor: string;
  isPDF: boolean;
  enableHighlight?: boolean;
  enableMistakeHighlight?: boolean;
}) => {
  const { fontSize } = useFontSize();
  const numericFontSize = Number(fontSize);
  const { name, email, phone, url1, url2, location } = profile;
  const iconProps = { email, phone, location, url1, url2 };

  return (
    <TemplateTwentyOneProfileSection themeColor={themeColor}>
      <ResumePDFText
        themeColor={themeColor}
        style={{
          backgroundColor: "#434445",
          color: "white",
          fontSize: "35pt",
          textAlign: "center",
          paddingTop:"20pt",
          letterSpacing: "1pt",
          textTransform:"uppercase"
        }}
      >
        {name}
      </ResumePDFText>
      <View
        style={{
          ...styles.flexRow,
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          columnGap: 15,
          rowGap: 5,
          paddingTop:spacing["2"],
          paddingBottom:spacing["2"],
          marginTop: spacing["0.5"],
          marginBottom:"2pt",
          
          backgroundColor: themeColor
        }}
      >
        {Object.entries(iconProps).map(([key, value], index) => {
    if (!value) return null;

    let iconType = key as IconType;
    let displayValue = value;
    if (key === "url1" || key === "url2") {
      if (value.includes("github")) {
        iconType = "url_github";
      } else if (value.includes("linkedin")) {
        iconType = "url_linkedin";
      } else if (value.includes("behance")) {
        iconType = "url_behance";
      } else if (value.includes("dribble")) {
        iconType = "url_dribble";
      }
      displayValue = extractUsernameFromURL(value);
    }

    const shouldUseLinkWrapper = ["email", "url1", "url2", "phone"].includes(key);
    const Wrapper = ({ children }: { children: React.ReactNode }) => {
      if (!shouldUseLinkWrapper) return <>{children}</>;

      let src = "";
      switch (key) {
        case "email": {
          src = `mailto:${value}`;
          break;
        }
        case "phone": {
          src = `tel:${value.replace(/[^\d+]/g, "")}`; // Keep only + and digits
          break;
        }
        default: {
          src = value.startsWith("http") ? value : `https://${value}`;
        }
      }

      return (
        <ResumePDFLink src={src} isPDF={isPDF}>
          {children}
        </ResumePDFLink>
      );
    };

    return (
      <View
        key={key}
        style={{
          ...styles.flexRow,
          alignItems: "center",
          justifyContent: "center",
          gap: spacing["1"],
          
        }}
      >
        <ResumePDFIcon
          type={iconType}
          isPDF={isPDF}
          themeColor={"white"}
          
        />
        <Wrapper>
          <ResumePDFText style={{ fontSize: `${numericFontSize * 0.583}pt`, color:"white" }}>{displayValue}</ResumePDFText>
        </Wrapper>

        
        {index < Object.entries(iconProps).length - 1 && (
          <View
            style={{
              width: 6,
              height: 6,
              borderRadius: 3,
              marginLeft:spacing["2"],
              backgroundColor: "white",
              marginHorizontal: 10,
            }}
          />
        )}
      </View>
    );
  })}
      </View>
    </TemplateTwentyOneProfileSection>
  );
};
